import * as React from 'react';
import {connect} from 'react-redux';
import {IFamilyMember} from '@app-types/websocket/family.types';
import {WithStyles, withStyles,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import {imageFlowStyle} from './imageflow.style';
import {FamilyMemberType} from '@services/family/family.constants';
import ImageFlowPost from './ImageFlowPost';
import {IFlowPost, IRequestFlowPosts} from '@app-types/websocket/imageflow.types';
import * as ImageFlowActions from '@services/imageflow/imageflow.actions';
import ImageFlowPostNew from './ImageFlowPostNew';
import AddIcon from '@material-ui/icons/Add';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof imageFlowStyle> {
  viewRef: HTMLDivElement | null;
  userRole: FamilyMemberType;
  user?: IFamilyMember;
  userId: number;
  family: IFamilyMember[];
  scrollTime: number;
  posts: IFlowPost[];
  hideFAB:boolean;
  loadMore: (data: IRequestFlowPosts) => void;
}

interface IState {
  loadTime: number;
  openNew: boolean;
}

class ImageFlowContainer extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      loadTime: 0,
      openNew: false,
    };

  }

  public componentDidUpdate(oldProps:IProps) {
    if (oldProps.scrollTime !== this.props.scrollTime && this.state.loadTime < (Date.now() - 1000)) {
      if (this.props.viewRef) {
        if((this.props.viewRef.scrollTop+this.props.viewRef.clientHeight+100) > this.props.viewRef.scrollHeight) {
          this.loadMore();
        }
      }
    }
  }

  public render() {
    const {classes, hideFAB} = this.props;
    const accounts: number[] = [];
    for (const mem of this.props.family) {
      if (mem.role === FamilyMemberType.PARENT) {
        accounts.push(mem.id);
      }
    }

    return (
      <>
        <div className={classes.root}>
          {this.props.posts.length === 0 
            && (<div style={{display:'flex', flexDirection:'column', position: 'absolute', top: '100px', 
              left: 'calc(50% - 120px)', width:'240px', alignItems:'center'}}>
              <p className={classes.helpText}>{tn.lang.flowTip1}</p>
              <p className={classes.helpText}>{tn.lang.flowTip2}</p>
              <img src={'arrow.png'} style={{ width: '60px'}} alt="Arrow" />
            </div>)
          }
          <div
            className={classes.imagesList}>
            {this.props.posts.map((p, i) =>
              <ImageFlowPost
                scrollTime={this.props.scrollTime}
                key={p.postId}
                family={this.props.family}
                user={this.props.user}
                post={p}
              />)}
            <div style={{height: 100}}/>
          </div>
        </div>
        <ImageFlowPostNew open={this.state.openNew} close={() => this.setState({openNew: false})}/>
        <div className={classes.FAB} onClick={() => this.setState({openNew: true})}
          style={{scale:(hideFAB?"0":"1"), pointerEvents:(hideFAB?"none":"auto")}}>
          <AddIcon style={{fontSize:'42px'}}/>
        </div>
      </>
    );
  }

  private loadMore() {
    this.setState({loadTime:Date.now()});
    if (this.props.posts && this.props.posts.length > 0) {
      this.props.loadMore({numPostBack: 5, startId: this.props.posts[this.props.posts.length - 1].postId});
    }
  }
}

function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;
  const family: IFamilyMember[] = state.family.family;
  const posts: IFlowPost[] = state.posts.posts;
  let userRole = FamilyMemberType.VIEWER;
  let user: IFamilyMember | undefined = family.find((mem: IFamilyMember) => mem.id === userId);

  for (const mem of family) {
    if (mem.id === userId) {
      userRole = mem.role;
      user = mem;
    }
  }
  return {
    userRole,
    family,
    userId,
    user,
    posts,
  };
}

const mapDispatchToProps = {
  loadMore: ImageFlowActions.imageFlowRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(imageFlowStyle)(ImageFlowContainer));



// WEBPACK FOOTER //
// ./src/components/imageflow/ImageFlowContainer.tsx